<template>
  <v-select
    v-model="data"
    v-bind="$attrs"
    :items="weekdayItems"
    item-text="label"
    item-value="value"
    :multiple="multi"
  />
</template>

<script>
import ModelMixin from '../../mixins/model';

export default {
  mixins: [
    ModelMixin,
  ],

  props: {
    value: [Number, Array],
    multi: Boolean,
    short: Boolean,
    stringValues: Boolean,
  },

  data() {
    return {
      data: undefined,
    };
  },

  computed: {
    weekdayItems() {
      const days = this.$t('common.daysOfWeek');
      let x = 0;
      return _.map(days, d => ({ label: d.long, value: x++ }));
    },
  },
};
</script>
